import { planGetPlusUrl, planGetProUrl, planPlanForUrl } from 'mk2/apps/plan/urls';
import { Route } from 'mk2/containers/Application/Application';

export const routes: Route[] = [{
    app: 'plan',
    exact: true,
    path: planGetPlusUrl,
    getPage: () => {
        return import('mk2/apps/plan/containers/GetPlus/GetPlusPage' /* webpackChunkName: "plus.GetPlus" */);
    },
    modules: [ 'mk2/apps/plus/containers/GetPlus/GetPlusPage' ],
}, {
    app: 'plan',
    exact: true,
    path: planGetProUrl,
    getPage: () => {
        return import('mk2/apps/plan/containers/GetPro/GetProPage' /* webpackChunkName: "plus.GetPro" */);
    },
    modules: [ 'mk2/apps/plus/containers/GetPro/GetProPage' ],
}, {
    app: 'plan',
    exact: true,
    path: planPlanForUrl,
    getPage: () => {
        return import('mk2/apps/plan/containers/PlanFor/PlanForPage' /* webpackChunkName: "plus.PlanFor" */);
    },
    modules: [ 'mk2/apps/plus/containers/PlanFor/PlanForPage' ],
}];
